import React from 'react'
import { Card, LocationInfo, AppointmentInfo } from './styled'
import { Button } from '../../ui/button'
import { Text1, Text2 } from '../../ui/text'
import { Calendar, Address } from '../../../assets/icons'
import { capitalizeEachWord } from '../../../utils/stringsUtils'
import colors from '../../../styles/colors'

const DoctorCard = ({
	doctor,
	clinicName,
	compact = false,
	selectable = false,
	selected = false,
	onSelect,
	onBook
}) => (
	<Card
		$compact={compact}
		$selectable={selectable}
		$selected={selected}
		onClick={selectable && onSelect ? () => onSelect(doctor.idTurno) : undefined}
	>
		<Text1
			as="h3"
			size={compact ? '16px' : '20px'}
			color={colors.text.titleText}
			style={{ margin: `0 0 ${compact ? '5px' : '4px'} 0` }}
		>
			{capitalizeEachWord(doctor.nombreProfesional)}
		</Text1>
		<Text2
			as="div"
			size="14px"
			color={compact ? colors.text.mutedText : colors.text.secondaryText}
			style={{ marginBottom: compact ? '10px' : '18px' }}
		>
			{capitalizeEachWord(doctor.nombreEspecialidad)}
		</Text2>
		<LocationInfo $compact={compact}>
			<Address />
			<div>
				<div>{capitalizeEachWord(clinicName || '')}</div>
				<div style={{ textDecoration: 'underline' }}>{doctor.direccion}</div>
			</div>
		</LocationInfo>
		<AppointmentInfo $compact={compact}>
			<Calendar size={16} color="#161616" />
			<span>
				Próximo turno: {compact ? doctor.fechaTurno : <strong>{doctor.fechaTurno}</strong>}
			</span>
		</AppointmentInfo>
		<Button
			$variant="secondary"
			label="Sacar turno"
			onClick={() => onBook(doctor.idProfesional, doctor.clinica)}
			style={{ maxWidth: '100%' }}
		/>
	</Card>
)

export default DoctorCard
